import { onWindowScroll } from 'utils';

class Header {
	get SELECTORS() {
		return {
			header: '.header',
		};
	}

	get CLASSNAMES() {
		return {
			bodyScrollState: 'body--scroll_state',
		};
	}

	constructor() {
		this.$body = document.body;
		this.$header = document.querySelector(this.SELECTORS.header);
		this.headerScroll = this.headerScroll.bind(this);

		this.init = this.init.bind(this);
		this.init();
	}

	headerScroll(windowScrollTop) {
		if (
			windowScrollTop > 10 &&
			!this.$body.classList.contains(this.CLASSNAMES.bodyScrollState)
		) {
			this.$body.classList.add(this.CLASSNAMES.bodyScrollState);
		}

		if (
			windowScrollTop <= 10 &&
			this.$body.classList.contains(this.CLASSNAMES.bodyScrollState)
		) {
			this.$body.classList.remove(this.CLASSNAMES.bodyScrollState);
		}
	}

	init() {
		if (typeof this.$header !== 'undefined' && this.$header != null) {
			onWindowScroll(this.headerScroll);
		}
	}
}

export default Header;
